module.exports = __webpack_public_path__ + "static/media/right-chevron.12307bd4.svg";